import React, { useRef, useState, useEffect } from "react";
import headshot from "../../imgs/headshot.jpg";

import "./About.css";

export default function About() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "About hidden " + (isVisible ? "show" : "");

    const skillGroups = [
        {
            title: "Websites",
            items: [
                "Business websites and landing pages",
                "Mobile-friendly layouts",
                "Performance and SEO basics",
                "WordPress cleanup and optimization",
            ],
        },
        {
            title: "Automation",
            items: [
                "Workflow automation",
                "Email and notification systems",
                "Form-to-database flows",
                "n8n and custom integrations",
            ],
        },
        {
            title: "AI and Tools",
            items: [
                "Business AI assistants",
                "Internal knowledge tools",
                "Document processing",
                "Connected workflows with Google Drive, email, and spreadsheets",
            ],
        },
        {
            title: "Consulting",
            items: [
                "Practical systems advice",
                "Tool selection and cleanup",
                "Digitizing office processes",
                "Custom dashboards and portals",
            ],
        },
    ];

    return (
        <section ref={targetRef} className={className} id="about">
            <h1 className="title">About Riley</h1>
            <div className="about-top">
                <div className="about-bio">
                    <p className="about-me">
                        Riley Gramlich is the owner and consultant behind Gramlich Software Services, helping small businesses modernize the way they work with better websites, automation, and practical software.
                    </p>
                    <p className="about-me about-me-secondary">
                        The focus is on clear communication, useful outcomes, and solutions that fit the way a business already operates.
                    </p>
                    <p className="about-me about-me-secondary">
                        <a href="https://rileygramlich.dev" target="_blank" rel="noreferrer">About Riley</a>
                    </p>
                </div>

                <figure className="about-photo-panel">
                    <img
                        src={headshot}
                        alt="Riley Gramlich"
                        className="about-photo"
                    />
                </figure>
            </div>

            <div className="capability-list">
                <h3>What clients can expect</h3>
                <ul>
                    <li>Clear timelines and straightforward communication</li>
                    <li>Solutions that fit real team workflows</li>
                    <li>Modern tools without unnecessary complexity</li>
                    <li>Support for teams that need practical improvements, not hype</li>
                </ul>
            </div>

            <div className="skills-contain">
                <h3 id="skills">Capabilities</h3>
                <div className="skills-columns">
                    {skillGroups.map((group) => (
                        <article key={group.title} className="skills-column">
                            <h4>{group.title}</h4>
                            <ul>
                                {group.items.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
